/**
 * @section 4.1.9.2
 */
import React from "react";
import { t } from "i18next";
import InitialIcon from "@material-ui/icons/AssignmentOutlined";
import { makeThemedStyles } from "./../../viewcomponents/utils";
const useStyles = makeThemedStyles("TextSelectKpiFromList", (theme) => ({
  initialText: {
    marginTop: "150px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    opacity: 0.2,
  },
}));
const TextSelectKpiFromList = () => {
  const classes = useStyles();
  return (
    <div className={classes.initialText}>
      <InitialIcon
        style={{ width: "70px", height: "70px", color: "#40848a" }}
      />
      <div>{t("Select kpi from the list on left")}</div>
    </div>
  );
};
export default TextSelectKpiFromList;
